export type InquiryRequestType = "quick" | "detailed";

export interface InquiryPayload {
  schemaVersion: 1;
  requestId: string;
  requestType: InquiryRequestType;
  submittedAt: string;
  source: "autogutverkaufen.de";
  contact: {
    name: string;
    email: string;
    phone: string;
  };
  vehicle: {
    maker: string;
    model: string;
    mileage: string;
    initialRegistration: string;
    /** Fahrzeugstandort (PLZ / Ort); optional für ältere Clients. */
    location?: string;
  };
  details?: {
    location: string;
    vin: string;
    knownDefects: string;
    specialEquipment: string;
    accidentDamage: string;
    accidentDetails: string;
    serviceBook: string;
    tuvAu: string;
    holderCount: string;
    keyCount: string;
    vatDeductible: string;
    hasAskingPrice: string;
    askingPrice: string;
    desiredResultDate: string;
    tires: string[];
    documents: string[];
    catChecks: string[];
  };
}

export function createRequestId() {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
